import React from "react";
import {
  DetailCardContainer,
  DetailCardCircle,
  DetailCardDescription,
} from "./styled/DetailCard.styled";

export default function DetailCard({ emboss, description, imagesrc }) {
  return (
    <>
      <DetailCardContainer>
        <DetailCardCircle>
          <img src={imagesrc} alt="logo" width="60" className="center" />
        </DetailCardCircle>
        <DetailCardDescription emboss={emboss}>
          {description}
        </DetailCardDescription>
      </DetailCardContainer>
    </>
  );
}
